import React, { useState } from 'react'
import { Backdrop, CircularProgress, Typography } from '@mui/material'

import useStyles from './useStyles'
import { Navigate, Route, Routes } from 'react-router-dom'
import UsersForSuscriber from './Users/Users'
import { SearchSubscriber } from './SearchSubscriber/SearchSubscriber'
import OrganizationsOfUSuscriber from './Organizations/Organizations'
import { Suscriptions } from './Products/Products'
import InfoIcon from '@mui/icons-material/Info'

export default function Suscribers () {
  return (
    <Routes>
      <Route path="/" element={<Subscriber />} />
      <Route path="/:id" element={<Subscriber />} />
      <Route path=":id/users" element={<UsersForSuscriber />} />
      <Route path=":id/organizations" element={<OrganizationsOfUSuscriber />} />
      <Route path=":id/suscriptions" element={<Suscriptions />} />
      <Route path="*" element={<Navigate replace to="/home" />} />
    </Routes>
  )
}
function Subscriber () {
  const classes = useStyles()

  const [loading, setLoading] = useState(false)

  const handleClose = () => {
    setLoading(false)
  }

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>Suscriptores</Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá visualizar la información de un suscriptor de
          Errepar+.
        </Typography>
      </div>
      <SearchSubscriber setLoading={setLoading} />

      {/* <div className={classes.boxsearch}>
        <SearchSubscriber setLoading={setLoading} />
      </div> */}
    </div>
  )
}
